import React from "react";
import { UserPictureCache, useMemberPicture } from "Hooks";
import { AvatarCircle, AvatarCircleProps } from "./AvatarCircle";
import { getAvatarColorIndex } from ".";

type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;

interface AvatarCircleWithCacheProps extends Optional<AvatarCircleProps, "colorIndex"> {
   cache: UserPictureCache;
   userId: Guid;
}

const AvatarCircleWithCache: React.FC<AvatarCircleWithCacheProps> = ({
   cache,
   userId,
   colorIndex,
   imageUrl,
   ...props
}) => {
   const color = getAvatarColorIndex(userId);
   const memberPicture = useMemberPicture(cache, userId);

   return (
      <AvatarCircle
         colorIndex={colorIndex ?? color}
         imageUrl={imageUrl ?? memberPicture}
         {...props}
      />
   );
};

export default AvatarCircleWithCache;
